import DynamicWidgetRenderer from "@/components/DynamicWidgetRenderer";
import { CalendarBlock } from "@moim/blockit";
import { useLocation } from "wouter";
import React from "react";

interface IProps {
  event: Moim.Blockit.V2.Calendar.IEvent;
  hasTemplate?: boolean;
}

const EventItem = ({ event, hasTemplate }: IProps) => {
  const [, setLocation] = useLocation();

  const handleLinkClick = React.useCallback((link: string) => {
    setLocation(link);
  }, []);

  return (
    <CalendarBlock.EventItemContainer
      event={event}
      hasTemplate={hasTemplate}
      DynamicWidgetRendererCreator={(content: string) => (
        <DynamicWidgetRenderer key={`event_dw_${event.id}`} content={content} />
      )}
      onLinkClick={handleLinkClick}
    />
  );
};

export default EventItem;
